!function (global) {
  'use strict';

  var previousResultJobOffersServices = global.ResultJobOffersServices;

  function ResultJobOffersServices() {
    function getResults(params, url) {
      return $.ajax({
        method: 'POST',
        url: url,
        data: JSON.stringify(params),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8'
      });
    }
    
    function getAuxFiltersResponse(data) {
      var auxFiltersResponse = {};

      auxFiltersResponse = data.filters;
      auxFiltersResponse.areas = [];
      auxFiltersResponse.cities = [];
      auxFiltersResponse.salaries = [];

      return auxFiltersResponse;
    }

    return {
      getResults: getResults,
      getAuxFiltersResponse: getAuxFiltersResponse
    }
  }

  ResultJobOffersServices.noConflict = function noConflict() {
    global.ResultJobOffersServices = previousResultJobOffersServices;
    return ResultJobOffersServices;
  };

  global.ResultJobOffersServices = ResultJobOffersServices;
}(this);